import * as DefaultThemes from '../pages/Theming/constants/defaultThemes/index.js';

/**
 * Returns the default theme style for a specified product and included categories.
 *
 * @param {string} product - The product for which the default theme style is to be returned.
 * @param {Set<string>} [includedCategories=new Set(['theming-ui'])] - The categories to be included in the default theme style.
 * @returns {Object} The default theme style for the specified product and included categories.
 *
 * @example transforms into more compact code
 * {
 *   "section1": {
 *     "row1": {
 *       "style1": "value1",
 *       "style2": "value2"
 *     }
 *   }
 * }
 */
export const getDefaultThemeStyle = (product, includedCategories = new Set(['theming-ui'])) => {
  const sections = DefaultThemes[product].sections;

  const filterByCategories = ({ categories }) => {
    if (!categories) return true;

    return categories.some((category) => includedCategories.has(category));
  };

  return Object.fromEntries(
    sections
      .filter(filterByCategories)
      .map((section) => [
        section.id,
        Object.fromEntries(
          section.rows.map((row) => [
            row.key,
            Object.fromEntries(
              row.fields.map((style) => [
                style.key,
                style.type === 'section'
                  ? Object.fromEntries(style.fields.map((field) => [field.key, field.defaultValue]))
                  : style.defaultValue,
              ]),
            ),
          ]),
        ),
      ]),
  );
};
